<template>
  <Toast loading type="info-primary">
    <template #title>{{ $t('PastingToast.title') }}</template>
    <span v-if="progress && progress.total > 500">
      {{ $t('PastingToast.progress', progress) }}
    </span>
    <span v-else>{{ $t('PastingToast.content') }}</span>
  </Toast>
</template>

<script>
import Toast from '@onedesk/modules/core/components/toasts/Toast'
export default {
  name: 'PastingToast',
  components: {
    Toast,
  },
  computed: {
    progress() {
      return this.$store.state.toast.pastingProgress
    },
  },
}
</script>
